require('./bootstrap');
window.Vue = require('vue').default;

import Vuetify from 'vuetify';

Vue.use(Vuetify);

import Vuex from 'vuex';

Vue.use(Vuex);

import VueRouter from 'vue-router';

Vue.use(VueRouter);

const store = new Vuex.Store({
    state: {
        adminNavDrawer: false,
        selectedNavItem: -1,
        user: null,
        statusText: null,
        isShowStatus: false,
        errorText: null,
        isShowError: false,
        navs: [],
    },
    mutations: {
        updateNavs(state, value) {
            state.navs = value;
        },
        updateIsShowError(state, value) {
            state.isShowError = value;
        },
        updateErrorText(state, value) {
            state.errorText = value;
        },
        updateIsShowStatus(state, value) {
            state.isShowStatus = value;
        },
        updateStatusText(state, value) {
            state.statusText = value;
        },
        updateUser(state, value) {
            state.user = value;
        },
        updateSelectedNavItem(state, value) {
            state.selectedNavItem = value;
        },
        updateAdminNavDrawer(state, value) {
            state.adminNavDrawer = value;
        },
    }
});

Vue.component('login', function (resolve) {
    require(['./components/auth/Login'], resolve)
});
Vue.component('base-layout', function (resolve) {
    require(['./components/BaseLayout'], resolve)
});
Vue.component('main-nav', function (resolve) {
    require(['./components/Nav/Nav.vue'], resolve)
});
Vue.component('main-nav-list', function (resolve) {
    require(['./components/Nav/NavList.vue'], resolve)
});
Vue.component('system-alert', function (resolve) {
    require(['./components/SystemAlert.vue'], resolve)
});
Vue.component('app-bar', function (resolve) {
    require(['./components/AppBar.vue'], resolve)
});
Vue.component('cyrillic-filter-input', function (resolve) {
    require(['./components/inputs/CyrillicFilterInput'], resolve)
});
Vue.component('camera', function (resolve) {
    require(['./components/inputs/Camera'], resolve)
});
Vue.component('password-input', function (resolve) {
    require(['./components/inputs/PasswordInput'], resolve)
});
Vue.component('phone-input', function (resolve) {
    require(['./components/inputs/PhoneInput'], resolve)
});
Vue.component('date-time-input', function (resolve) {
    require(['./components/inputs/DateTimeInput'], resolve)
});
Vue.component('image-loader', function (resolve) {
    require(['./components/inputs/ImageLoader'], resolve)
});
Vue.component('search-data-table', function (resolve) {
    require(['./components/SearchDataTable'], resolve)
});
Vue.component('data-table', function (resolve) {
    require(['./components/DataTable'], resolve)
});

const Index = () => import('./components/Index');
const PageNotFound = () => import('./components/PageNotFound');
const UserIndex = () => import('./components/user/UserIndex');
const UserCreate = () => import('./components/user/UserCreate');
const UserEdit = () => import('./components/user/UserEdit');
const RoleIndex = () => import('./components/role/RoleIndex');
const RoleCreate = () => import('./components/role/RoleCreate');
const RoleEdit = () => import('./components/role/RoleEdit');
const CustomerIndex = () => import('./components/customer/CustomerIndex');
const CustomerEdit = () => import('./components/customer/CustomerEdit');
const CustomerInform = () => import('./components/customer/CustomerInform');
const OrderIndex = () => import('./components/order/OrderIndex');
const OrderCreate = () => import('./components/order/OrderCreate');
const OrderCreateUpBalance = () => import('./components/order/OrderCreateUpBalance');
const OrderEdit = () => import('./components/order/OrderEdit');
const CityIndex = () => import('./components/city/CityIndex');
const CityCreate = () => import('./components/city/CityCreate');
const CityEdit = () => import('./components/city/CityEdit');
const StreetIndex = () => import('./components/street/StreetIndex');
const StreetCreate = () => import('./components/street/StreetCreate');
const StreetEdit = () => import('./components/street/StreetEdit');
const WashingProgramIndex = () => import('./components/washingProgram/WashingProgramIndex');
const WashingProgramCreate = () => import('./components/washingProgram/WashingProgramCreate');
const WashingProgramEdit = () => import('./components/washingProgram/WashingProgramEdit');
const DeviceIndex = () => import('./components/device/DeviceIndex');
const DeviceCreate = () => import('./components/device/DeviceCreate');
const DeviceEdit = () => import('./components/device/DeviceEdit');
const AddressIndex = () => import('./components/address/AddressIndex');
const AddressCreate = () => import('./components/address/AddressCreate');
const AddressEdit = () => import('./components/address/AddressEdit');
const PaymentMethodIndex = () => import('./components/paymentMethod/PaymentMethodIndex');
const PaymentMethodCreate = () => import('./components/paymentMethod/PaymentMethodCreate');
const PaymentMethodEdit = () => import('./components/paymentMethod/PaymentMethodEdit');
const OrganisationIndex = () => import('./components/organisation/OrganisationIndex');
const OrganisationCreate = () => import('./components/organisation/OrganisationCreate');
const OrganisationEdit = () => import('./components/organisation/OrganisationEdit');
const ServiceIndex = () => import('./components/service/ServiceIndex');
const ServiceCreate = () => import('./components/service/ServiceCreate');
const ServiceEdit = () => import('./components/service/ServiceEdit');
const PriceIndex = () => import('./components/price/PriceIndex');
const PriceCreate = () => import('./components/price/PriceCreate');
const PriceEdit = () => import('./components/price/PriceEdit');
const routes = [
    {
        path: '/',
        component: Index,
        name: 'index',
        meta: {
            title: 'Прачка',
        }
    },
    {
        path: '/users',
        component: UserIndex,
        name: 'users',
        meta: {
            title: 'Співробітники',
        }
    },
    {
        path: '/user/create/:parentQuery?',
        component: UserCreate,
        name: 'UserCreate',
        meta: {
            title: 'Створення співробітника',
        }
    },
    {
        path: '/user/edit/:id/:parentQuery?',
        component: UserEdit,
        name: 'UserEdit',
        props: true,
        meta: {
            title: 'Редагування співробітника',
        }
    },
    {
        path: '/roles',
        component: RoleIndex,
        name: 'RoleIndex',
        meta: {
            title: 'Ролі',
        }
    },
    {
        path: '/role/create/:parentQuery?',
        component: RoleCreate,
        name: 'RoleCreate',
        meta: {
            title: 'Створення ролі',
        }
    },
    {
        path: '/role/edit/:id/:parentQuery?',
        component: RoleEdit,
        name: 'RoleEdit',
        props: true,
        meta: {
            title: 'Редагування ролі',
        }
    },
    {
        path: '/customers',
        component: CustomerIndex,
        name: 'CustomerIndex',
        meta: {
            title: 'Клієнти',
        }
    },
    {
        path: '/customer/edit/:id/:parentQuery?',
        component: CustomerEdit,
        name: 'CustomerEdit',
        props: true,
        meta: {
            title: 'Редагування клієнта',
        }
    },
    {
        path: '/customer/inform/:id/:parentQuery?',
        component: CustomerInform,
        name: 'CustomerInform',
        props: true,
        meta: {
            title: 'Інформація про клієтна',
        }
    },
    {
        path: '/orders',
        component: OrderIndex,
        name: 'OrderIndex',
        meta: {
            title: 'Замовлення',
        }
    },
    {
        path: '/order/create/:parentQuery?',
        component: OrderCreate,
        name: 'OrderCreate',
        meta: {
            title: 'Створення замовлення',
        },
    },
    {
        path: '/order/create/upBalance/:parentQuery?',
        name: 'OrderCreateUpBalance',
        component: OrderCreateUpBalance,
        meta: {
            title: 'Поповлення балансу',
        },
    },
    {
        path: '/order/edit/:id/:parentQuery?',
        component: OrderEdit,
        name: 'OrderEdit',
        props: true,
        meta: {
            title: 'Редагування замовлення',
        }
    },
    {
        path: '/cities',
        component: CityIndex,
        name: 'CityIndex',
        meta: {
            title: 'Міста',
        }
    },
    {
        path: '/city/create/:parentQuery?',
        component: CityCreate,
        name: 'CityCreate',
        meta: {
            title: 'Створення міста',
        }
    },
    {
        path: '/city/edit/:id/:parentQuery?',
        component: CityEdit,
        name: 'CityEdit',
        props: true,
        meta: {
            title: 'Редагування міста',
        }
    },
    {
        path: '/streets',
        component: StreetIndex,
        name: 'StreetIndex',
        meta: {
            title: 'Вулиці',
        }
    },
    {
        path: '/street/create/:parentQuery?',
        component: StreetCreate,
        name: 'StreetCreate',
        meta: {
            title: 'Створення вулиці',
        }
    },
    {
        path: '/street/edit/:id/:parentQuery?',
        component: StreetEdit,
        name: 'StreetEdit',
        props: true,
        meta: {
            title: 'Редагування вулиці',
        }
    },
    {
        path: '/washingPrograms',
        component: WashingProgramIndex,
        name: 'WashingProgramIndex',
        meta: {
            title: 'Програми',
        }
    },
    {
        path: '/washingProgram/create/:parentQuery?',
        component: WashingProgramCreate,
        name: 'WashingProgramCreate',
        meta: {
            title: 'Створення програми',
        }
    },
    {
        path: '/washingProgram/edit/:id/:parentQuery?',
        component: WashingProgramEdit,
        name: 'WashingProgramEdit',
        props: true,
        meta: {
            title: 'Редагування програми',
        }
    },
    {
        path: '/devices',
        component: DeviceIndex,
        name: 'DeviceIndex',
        meta: {
            title: 'Обладнання',
        }
    },
    {
        path: '/device/create/:parentQuery?',
        component: DeviceCreate,
        name: 'DeviceCreate',
        meta: {
            title: 'Створення обладнання',
        }
    },
    {
        path: '/device/edit/:id/:parentQuery?',
        component: DeviceEdit,
        name: 'DeviceEdit',
        props: true,
        meta: {
            title: 'Редагування обладнання',
        }
    },
    {
        path: '/addresses',
        component: AddressIndex,
        name: 'AddressIndex',
        meta: {
            title: 'Адреси',
        }
    },
    {
        path: '/address/create/:parentQuery?',
        component: AddressCreate,
        name: 'AddressCreate',
        meta: {
            title: 'Створення адреси',
        }
    },
    {
        path: '/address/edit/:id/:parentQuery?',
        component: AddressEdit,
        name: 'AddressEdit',
        props: true,
        meta: {
            title: 'Редагування адреси',
        }
    },
    {
        path: '/paymentMethods',
        component: PaymentMethodIndex,
        name: 'PaymentMethodIndex',
        meta: {
            title: 'Способи оплати',
        }
    },
    {
        path: '/paymentMethod/create/:parentQuery?',
        component: PaymentMethodCreate,
        name: 'PaymentMethodCreate',
        meta: {
            title: 'Створення способу оплати',
        }
    },
    {
        path: '/paymentMethod/edit/:id/:parentQuery?',
        component: PaymentMethodEdit,
        name: 'PaymentMethodEdit',
        props: true,
        meta: {
            title: 'Редагування способу оплати',
        }
    },
    {
        path: '/organisations',
        component: OrganisationIndex,
        name: 'OrganisationIndex',
        meta: {
            title: 'Організації',
        }
    },
    {
        path: '/organisation/create/:parentQuery?',
        component: OrganisationCreate,
        name: 'OrganisationCreate',
        meta: {
            title: 'Створення організації',
        }
    },
    {
        path: '/organisation/edit/:id/:parentQuery?',
        component: OrganisationEdit,
        name: 'OrganisationEdit',
        props: true,
        meta: {
            title: 'Редагування організації',
        }
    },
    {
        path: '/services',
        component: ServiceIndex,
        name: 'ServiceIndex',
        meta: {
            title: 'Послуги',
        }
    },
    {
        path: '/service/create/:parentQuery?',
        component: ServiceCreate,
        name: 'ServiceCreate',
        meta: {
            title: 'Створення послуги',
        }
    },
    {
        path: '/service/edit/:id/:parentQuery?',
        component: ServiceEdit,
        name: 'ServiceEdit',
        props: true,
        meta: {
            title: 'Редагування послуги',
        }
    },
    {
        path: '/prices',
        component: PriceIndex,
        name: 'PriceIndex',
        meta: {
            title: 'Ціни',
        }
    },
    {
        path: '/price/create/:parentQuery?',
        component: PriceCreate,
        name: 'PriceCreate',
        meta: {
            title: 'Створення ціни',
        }
    },
    {
        path: '/price/edit/:id/:parentQuery?',
        component: PriceEdit,
        name: 'PriceEdit',
        props: true,
        meta: {
            title: 'Редагування ціни',
        }
    },
    {
        path: "*",
        component: PageNotFound,
        name: 'pageNotFound',
        meta: {
            title: '404',
        }
    },
];

const Router = new VueRouter({
    routes,
    mode: 'history',
    base: '/',
});

if (!!Router) {
    Router.beforeEach((to, from, next) => {
        try {
            if (!!from && !!from.params && !!from.params.parentQuery) {
                if (typeof from.params.parentQuery === 'string') {
                    let parentQuery = JSON.parse(from.params.parentQuery);
                    for (const [key, value] of Object.entries(parentQuery)) {
                        to.query[key] = value;
                    }
                }
            }
            next();
        } catch (e) {
            console.log(e);
        } finally {
            next();
        }
    });
}

const app = new Vue({
    el: '#app',
    store,
    vuetify: new Vuetify({
        theme: { dark: true },
    }),
    router: Router,
});
